import React from 'react';
import Box from '@mui/material/Box';
import Preview from '../previews/LongText';

const LongTextQuestion = ({ activeStep, question }) => {
  return <Box></Box>;
};

LongTextQuestion.StepsCount = 2;
LongTextQuestion.StepDescription = '';
LongTextQuestion.Preview = Preview;

export default LongTextQuestion;
